import React from 'react';
import RadioButton from '../../../../../components/radioButton/RadioButton';
import CheckBox from '../../../../../components/checkBox/CheckBox';
import Input from '../../../../../components/inputText/Input';
import TextArea from '../../../../../components/TextArea/TextArea';
import Autocomplete from '../../../../../components/Autocomplete/Autocomplete';
import Button from '../../../../../components/Button/Button';
import ModaleAnnulla from '../../../../../components/modaleAnnulla/ModaleAnnulla';

function Assistito({dati, onChange, onProsegui, onAnnulla}) {
    const comuni = JSON.parse(sessionStorage.getItem("comuni") || "[]")
    const comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice") || "{}")

    function validateConferma() {
        const missingContatto = !dati.telefono && !dati.cellulare && !dati.email
        return !dati.sessoAssistito || missingContatto
    }

    return (
        <div style={{marginTop: "30px"}}>

            <div style={{paddingBottom: "10px", borderBottom: "1px solid #dee2e6", marginBottom: "20px"}}>
                <h5 style={{fontWeight: "bold"}}>Persona da assistere</h5>
            </div>

            <div className={"row"} style={{marginBottom: "20px"}}>
                <div className={"col-md-3"}>
                    <label style={{fontWeight: "bold", display: "block", marginBottom: "8px"}}>Sesso *</label>
                    <RadioButton id={"sessoAssistito_M"} value={"M"} text={"Uomo"}
                        checked={dati.sessoAssistito === "M"}
                        onChange={(e) => onChange("sessoAssistito", e.target.value)}/>
                    <RadioButton id={"sessoAssistito_F"} value={"F"} text={"Donna"}
                        checked={dati.sessoAssistito === "F"}
                        onChange={(e) => onChange("sessoAssistito", e.target.value)}/>
                </div>
                <div className={"col-md-4"}>
                    <label style={{fontWeight: "bold", display: "block", marginBottom: "8px"}}>Comune</label>
                    <Autocomplete id={"comune"}
                        ariaLabel={"Comune"}
                        placeholder={"Cerca comune..."}
                        value={dati.comune ? comuniPerCodice[dati.comune] : null}
                        suggestions={comuni}
                        onChange={(id, val) => onChange(id, val?.codice || val)}/>
                </div>
            </div>

            <div style={{marginBottom: "20px"}}>
                <label style={{fontWeight: "bold", display: "block", marginBottom: "8px"}}>Condizioni</label>
                <div className={"row"}>
                    <div className={"col-md-2"}><CheckBox id={"autosufficiente"} text={"Autosufficiente"} checked={!!dati.autosufficiente} onChange={(e) => onChange("autosufficiente", e.target.checked)}/></div>
                    <div className={"col-md-3"}><CheckBox id={"parzialmenteAutosufficiente"} text={"Parz. autosufficiente"} checked={!!dati.parzialmenteAutosufficiente} onChange={(e) => onChange("parzialmenteAutosufficiente", e.target.checked)}/></div>
                    <div className={"col-md-2"}><CheckBox id={"carrozzina"} text={"In carrozzina"} checked={!!dati.carrozzina} onChange={(e) => onChange("carrozzina", e.target.checked)}/></div>
                    <div className={"col-md-2"}><CheckBox id={"allettata"} text={"Allettata"} checked={!!dati.allettata} onChange={(e) => onChange("allettata", e.target.checked)}/></div>
                    <div className={"col-md-2"}><CheckBox id={"disabilita"} text={"Disabilità mentale"} checked={!!dati.disabilita} onChange={(e) => onChange("disabilita", e.target.checked)}/></div>
                </div>
            </div>

            <div style={{marginBottom: "20px"}}>
                <label style={{fontWeight: "bold", display: "block", marginBottom: "8px"}}>Note</label>
                <TextArea id={"note"} ariaLabel={"Note"} placeholder={"Note aggiuntive..."}
                    value={dati.note || ""}
                    onChange={(e) => onChange("note", e.target.value)}
                    rows={3} style={{width: "100%"}}/>
            </div>

            <div style={{paddingBottom: "10px", borderBottom: "1px solid #dee2e6", marginBottom: "20px"}}>
                <h5 style={{fontWeight: "bold"}}>
                    Contatti{" "}
                    <small style={{fontWeight: "normal", fontSize: "14px"}}>(almeno uno obbligatorio)</small>
                </h5>
            </div>

            <div className={"row"} style={{marginBottom: "30px"}}>
                <div className={"col-md-3"}>
                    <label style={{display: "block", marginBottom: "4px"}}>Telefono</label>
                    <Input id={"telefono"} ariaLabel={"Telefono"} placeholder={"Telefono"} value={dati.telefono || ""}
                        onChange={(e) => onChange("telefono", e.target.value)}/>
                </div>
                <div className={"col-md-3"}>
                    <label style={{display: "block", marginBottom: "4px"}}>Cellulare</label>
                    <Input id={"cellulare"} ariaLabel={"Cellulare"} placeholder={"Cellulare"} value={dati.cellulare || ""}
                        onChange={(e) => onChange("cellulare", e.target.value)}/>
                </div>
                <div className={"col-md-3"}>
                    <label style={{display: "block", marginBottom: "4px"}}>Email</label>
                    <Input id={"email"} ariaLabel={"Email"} placeholder={"Email"} value={dati.email || ""}
                        onChange={(e) => onChange("email", e.target.value)}/>
                </div>
            </div>

            <div style={{display: "flex", gap: "10px", marginTop: "10px"}}>
                <Button
                    id={"buttonAnnullaAssistito"}
                    typeButton={"White"}
                    text={"Annulla"}
                    style={{height: "60px", width: "180px"}}
                    dataTarget={"modalAnnullaAssistito"}
                    dataToggle={"modal"}
                    dataBackdrop={"static"}
                    dataKeyboard={false}
                    body={<ModaleAnnulla onClick={onAnnulla}/>}
                    header={"Attenzione!"}
                />
                <Button typeButton={"Blue"} text={"Prosegui"}
                    disabled={validateConferma()} onClick={onProsegui}
                    style={{height: "60px", width: "180px"}}/>
            </div>
        </div>
    )
}

export default Assistito
